/**
 * @class
 * @extends mkE.Base
 */
D.Inspector = Class(
	/**
	 * @lends {D.Inspector#}
	 */
	{
		__construct: function ( par ) {
			this.par = par;
			let useLokalise = sessionStorage.getItem('insp-lokalise');
			this.node = mkE({
				tag: 'div',
				id: 'insp',
				className: '',
				els: [
					{
						tag: 'a',
						onclick: this.toggle
					},
					{
						tag: 'div',
						els: [
							{
								tag: 'label',
								els: [
									'Lokalise ',
									this.lokaliseSelector = mkE({
										tag: 'input',
										type: 'checkbox',
										onchange: this.onToggleLocalise,
										checked: useLokalise
									})
								]
							},
							' ',
							this.missingLocalisationsNode = mkE({
								tag: 'a',
								className: 'missing-localisations',
								onclick: this.showMissingLocalisations,
								style: {
									display: 'none'
								},
								text: ''
							})
						]
					}
				]
			});
			if( useLokalise ) {
				this.addLokalise();
			}
		},

		toggle() {
			toggleClassName(this.node, 'expanded');
		},

		onToggleLocalise() {
			if( this.lokaliseSelector.checked ) {
				sessionStorage.setItem('insp-lokalise', "1");
			} else {
				sessionStorage.removeItem('insp-lokalise');
			}
			window.location.reload();
		},

		missingLocalisations: [],

		addLokalise() {
			window.LOKALISE_CONFIG = {
				projectId: this.par.lokalise,
				locale: D.LANG,
				disableAdvancedHtml: true
			};
			let a = document.createElement("script");
			a.type = "text/javascript";
			a.async = !0;
			a.src = ["https://app.lokalise.com/live-js/script.min.js?", (new Date).getTime()].join("");
			document.body.appendChild(a);
			const langFunction = D.Lang.get.bind(this);
			D.Lang.get = function ( string, placeholder ) {
				if( !D.Lang.exists(string) ) {
					if( this.missingLocalisations.indexOf(string) === -1 ) {
						this.missingLocalisations.push(string);
					}
				}
				let re = langFunction(string, placeholder);
				if( string.search('url') === -1 ) {
					this.updateLokalise();
					re = `#L#${string}#${re}`;
				}
				return re;
			}.bind(this);
		},

		updateLokalise() {
			if( this.to ) {
				clearTimeout(this.to);
			}
			this.to = setTimeout(this.onUpdateLokalise, 200);
		},

		onUpdateLokalise() {
			const walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT);
			let node;
			while( node = walker.nextNode() ) {
				if( node.nodeValue.search('#L#') === 0 ) {
					const match = node.nodeValue.match(/#L#(.*?)#/);
					if( match[1] ) {
						node.parentNode.setAttribute('data-lokalise', '');
						node.parentNode.setAttribute('data-key', match[1]);
						node.nodeValue = node.nodeValue.substr(match[0].length);
					}
				}
			}
			document.dispatchEvent(new Event("lokalise-update-elements"));

			if( this.missingLocalisations.length > 0 ) {
				this.missingLocalisationsNode.style.display = '';
				this.missingLocalisationsNode.innerText = `${this.missingLocalisations.length} localisations not found`;
			}
		},

		showMissingLocalisations() {
			const modal = new T.Popup();
			modal.setContent(mkE({
				tag: 'ul',
				els: (() => {
					let re = [];
					for( let i = 0; i < this.missingLocalisations.length; i++ ) {
						const missingLocalisation = this.missingLocalisations[i];
						re.push({
							tag: 'li',
							text: missingLocalisation
						});
					}
					return re;
				})()
			}));
			modal.open();
		}
	},
	mkE.Base
);